import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { UUID } from '@macs-frontend/core/utils/uuid';
import { ConfirmPopupComponent, UserNotification } from '@macs-frontend/features/shared';

@Injectable({
  providedIn: 'root',
})
export class NotificationConfirmationDialogService {
  constructor(private dialog: MatDialog) {}

  openFormDialog(userNotification: UserNotification): Observable<any> {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      data: {
        title: userNotification.title ?? '',
        description: (userNotification.content ?? '').replace(/\n/g, '<br>'),
        cancelBtn: 'Cancel',
        confirmBtn: 'Mark as read',
        closeOnConfirm: true,
      },
    });
    return dialogRef.afterClosed();
  }
}
